module.exports = __webpack_public_path__ + "static/2-2d433c3fba4e948b84402a1b1a3838e4.jpg";